module.exports = __webpack_public_path__ + "img/creditCard.9216bf3d.png";